export default {
  CALCULATE_OVERALL_INVESTMENT_AMOUNT_QUERY: Symbol.for('CALCULATE_OVERALL_INVESTMENT_AMOUNT_QUERY'),
  OVERALL_INVESTMENT_AMOUNT_REPOSITORY: Symbol.for('OVERALL_INVESTMENT_AMOUNT_REPOSITORY'),
};
